import { ref, unref } from 'vue';

/* NPM Plugins */
import { ElForm } from 'element-plus';

/* Components */
import { CtTemplateForm } from "../forms/Index"

export const useCtTempForm = () => {

    const formRef = ref<typeof CtTemplateForm>()

    const elFormRef = ref<ComponentRef<typeof ElForm>>()

    const register = (ref: typeof CtTemplateForm, elRef: ComponentRef<typeof ElForm>) => {

        formRef.value = ref
        elFormRef.value = elRef

    }

    const methods = {

        getLoadStatus: () => {

            return unref(formRef)?.funcs.getLoadStatus()

        },

        setLoading: (isLoad: boolean) => {

            unref(formRef)?.funcs.setLoadStatus(isLoad);

        },

        setFormData: (data: any) => {

            unref(formRef)?.funcs.setFormData(data)

        },

        getFormData: () => {

            return unref(formRef)?.funcs.getFormData()

        }

    }

    return { elFormRef, register, methods }
}